// Shared economic calendar for accounting, provenance and comparison.
const MAX_WITHDRAWAL_PERIODS = 4;
const normalizeScheduleYears = value => Math.max(0, Math.round(Number(value) || 0));

function addWithdrawalPeriod(phases, label, startYear, requestedYears, totalYears, annualWithdrawal) {
  if (startYear > totalYears) return startYear;

  const years = Math.min(normalizeScheduleYears(requestedYears), Math.max(0, totalYears - startYear + 1));
  if (years <= 0) return startYear;

  const safeAnnualWithdrawal = Math.max(0, annualWithdrawal || 0);
  phases.push({
    label,
    startYear,
    endYear: startYear + years - 1,
    years,
    annualWithdrawal: safeAnnualWithdrawal,
    monthlyWithdrawal: safeAnnualWithdrawal / 12,
  });

  return startYear + years;
}

export function buildWithdrawalPeriods(params, fallbackWithdrawal = params.realWithdrawalYear0) {
  const {
    yearsToSimulate,
    realWithdrawalYear0,
    withdrawalPeriods,
    withdrawalScheduleEnabled,
    withdrawalScheduleMode,
    withdrawalPhase1Years,
    withdrawalPhase1Annual,
    withdrawalPhase2Years,
    withdrawalPhase2Annual,
  } = params;

  const years = normalizeScheduleYears(yearsToSimulate);
  const baseAnnual = Math.max(0, fallbackWithdrawal || realWithdrawalYear0 || 0);
  const phases = [];

  if (Array.isArray(withdrawalPeriods) && withdrawalPeriods.length > 0) {
    let nextStartYear = 1;

    withdrawalPeriods.slice(0, MAX_WITHDRAWAL_PERIODS).forEach((period, index) => {
      if (nextStartYear > years) return;

      const periodAnnual = period?.annualWithdrawal != null
        ? period.annualWithdrawal
        : period?.monthlyWithdrawal != null
        ? period.monthlyWithdrawal * 12
        : baseAnnual;

      nextStartYear = addWithdrawalPeriod(
        phases,
        `Periodo ${index + 1}`,
        nextStartYear,
        period?.years,
        years,
        periodAnnual
      );
    });

    if (nextStartYear <= years) {
      addWithdrawalPeriod(
        phases,
        `Periodo ${phases.length + 1}`,
        nextStartYear,
        years - nextStartYear + 1,
        years,
        baseAnnual
      );
    }

    return phases;
  }

  // Backward-compatible support for the previous "special periods + default" input shape.
  if (withdrawalScheduleEnabled) {
    let nextStartYear = 1;
    nextStartYear = addWithdrawalPeriod(
      phases,
      'Periodo 1',
      nextStartYear,
      withdrawalPhase1Years,
      years,
      Math.max(0, withdrawalPhase1Annual ?? baseAnnual)
    );

    if (withdrawalScheduleMode === 'two-periods') {
      nextStartYear = addWithdrawalPeriod(
        phases,
        'Periodo 2',
        nextStartYear,
        withdrawalPhase2Years,
        years,
        Math.max(0, withdrawalPhase2Annual ?? baseAnnual)
      );
    }

    if (nextStartYear <= years) {
      addWithdrawalPeriod(phases, 'Dopo i periodi', nextStartYear, years - nextStartYear + 1, years, baseAnnual);
    }

    return phases;
  }

  addWithdrawalPeriod(phases, 'Periodo 1', 1, years, years, baseAnnual);
  return phases;
}
